exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".roleType{margin-top:10px;width:250px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-732923cf!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/xiaoyuan/GX/Manager.vue
// module id = 575
// module chunks = 0